import { z } from 'zod/v4';
import { PaymentPlanEntryStatus, PaymentPlanStatus, } from '../../economy/payment-plans/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
const inputSchema = z.object({});
const outputSchema = z.object({
    status: z.enum(PaymentPlanStatus).nullable(),
    currency: z.string().nullable(),
    installments: z.array(z.object({
        amount: z.string().describe('Decimal amount in the case currency.'),
        dueDate: z.iso.date(),
        status: z.enum(PaymentPlanEntryStatus),
    })),
    installmentCount: z.number().int(),
    installmentsTruncated: z.boolean(),
    totalScheduled: z
        .string()
        .nullable()
        .describe('Decimal amount in the case currency.'),
    totalPaid: z
        .string()
        .nullable()
        .describe('Decimal amount in the case currency.'),
    progressFraction: z.number().nullable(),
    nextDueDate: z.iso.date().nullable(),
    nextDueAmount: z
        .string()
        .nullable()
        .describe('Decimal amount in the case currency.'),
    daysUntilNextDue: z.number().int().nullable(),
});
export const getCurrentPaymentPlanTool = {
    name: ToolName.GetCurrentPaymentPlan,
    category: ToolCategory.Vouchers,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Read the current payment plan on this case: either CREATED (exists but is not activated yet) or ACTIVE, with its installments and progress. When neither exists, all fields on the response are null/empty. Always call this before CREATE_PAYMENT_PLAN. Use search_payment_plans for the full history of plans on this case.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-current-payment-plan.js.map